import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class BuyBack extends BaseModel {
    fields =  {
      'costumer_id': {
        label: 'costumer_id',
        type: 'hidden',
        // rules: 'required'
      },
      'tanggal_transaksi': {
        label: 'Tanggal',
        type: 'date',
        rules: 'required'
      },
      'metode_pembayaran': {
        label: 'Metode pembayaran',
        type: 'enum',
        value: 'cash',
        options: {
          'cash': 'Cash',
          'transfer': 'Transfer',
          'edc': 'Edc',
          'qris': 'QRIS',
        },
        rules: 'required'
      },
      'catatan': {
        label: 'Catatan',
        type: 'textarea',
        rules: null
      },
      'approval_status': {
        label: 'Status Approval',
        type: 'hidden',
        rules: null
      },
    }
    endpoint = process.env.VUE_APP_API_URL + 'buy-backs'

    approve (id, decisions) {
      return axios.patch(this.endpoint + '/' + id + '/approve', {}).then(response => response.data)
    }
    setDisposition (id, decisions) { return axios.patch(this.endpoint + '/' + id + '/disposition', { detail_barang: decisions }).then(response => response.data) }
    uploadPhoto (id, detailId, file) { const data = new FormData(); data.append('foto', file); return axios.post(this.endpoint + '/' + id + '/details/' + detailId + '/photo', data).then(response => response.data) }

    submit (id) { return axios.patch(this.endpoint + '/' + id + '/submit').then(response => response.data) }
    reject (id, reason) { return axios.patch(this.endpoint + '/' + id + '/reject', { rejected_reason: reason }).then(response => response.data) }
    returnForRevision (id, reason) { return axios.patch(this.endpoint + '/' + id + '/return', { returned_reason: reason }).then(response => response.data) }

    create (value) {
      return new Promise((resolve, reject) => {
        const formData = this.initForEndpoint(value, true)
        this.appendDetails(formData, value.details)
        axios.post(this.endpoint, formData).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
    update (id, value) {
      return new Promise((resolve, reject) => {
        const formData = this.initForEndpoint(value, true)
        this.appendDetails(formData, value.details)

        value.deleted_ids.forEach((deleted_id, index) => {
          formData.append(`deleted_ids[${index}]`, deleted_id)
        });

        formData.append('_method', 'PATCH')
        axios.post(this.endpoint + '/' + id, formData).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
    appendDetails (formData, details = []) {
      details.forEach((detail, index) => {
        Object.keys(detail).forEach(field => {
          const fieldValue = detail[field]
          if (fieldValue === undefined || fieldValue === null || fieldValue === '') return
          const fieldName = `detail_barang[${index}][${field}]`
          if (typeof File !== 'undefined' && fieldValue instanceof File) {
            formData.append(fieldName, fieldValue, fieldValue.name)
          } else {
            formData.append(fieldName, fieldValue)
          }
        })
        if (!detail.qty) formData.append(`detail_barang[${index}][qty]`, 1)
      })
    }
}
